import React, { PureComponent } from 'react';

/*<style type="text/css">
  .st0{fill:#b6e08e;}
  .st1{fill:none;stroke:#000000;stroke-width:2;}
</style>*/

// in mt.css
//.Badge_easy rect.st0{fill:#b6e08e;}
//.Badge_easy rect.st1{fill:none;stroke:#000000;stroke-width:2;}

class EasyIcon extends PureComponent {
  render() {
    return (
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 26 30"
        style={{ enableBackground: 'new 0 0 26 30' }}
      >
        <g id="Symbol_5_1" transform="translate(-701 -137)">
          <g id="Rectangle_126" transform="translate(714 140)">
            <rect className="st0" width="6" height="26" />
            <rect x="1" y="1" className="st1" width="4" height="24" />
          </g>
          <g id="Rectangle_127" transform="translate(712 137)">
            <rect className="st0" width="10" height="6" />
            <rect x="1" y="1" className="st1" width="8" height="4" />
          </g>
          <g id="Rectangle_128" transform="translate(701 137)">
            <path
              className="st0"
              d="M3,0L3,0c1.7,0,3,1.3,3,3l0,0c0,1.7-1.3,3-3,3l0,0C1.3,6,0,4.7,0,3l0,0C0,1.3,1.3,0,3,0z"
            />
            <path
              className="st1"
              d="M3,1L3,1c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2l0,0C1.9,5,1,4.1,1,3l0,0C1,1.9,1.9,1,3,1z"
            />
          </g>
          <g id="Rectangle_129" transform="translate(711 145)">
            <rect className="st0" width="12" height="6" />
            <rect x="1" y="1" className="st1" width="10" height="4" />
          </g>
          <g id="Rectangle_130" transform="translate(709 153)">
            <rect className="st0" width="16" height="6" />
            <rect x="1" y="1" className="st1" width="14" height="4" />
          </g>
          <g id="Rectangle_131" transform="translate(707 161)">
            <rect className="st0" width="20" height="6" />
            <rect x="1" y="1" className="st1" width="18" height="4" />
          </g>
          <rect id="Rectangle_132" x="703" y="141" width="2" height="26" />
        </g>
      </svg>
    );
  }
}

export default EasyIcon;
